/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
import React from "react";
import {
  TableContainer,
  TableCell,
  TableRow,
  TableHead,
  Table as MuiTable,
  Box,
  TableBody,
} from "@mui/material";
import PropTypes from "prop-types";
import Typography from "../../../../../components/common/new/Typography/Typography";
import IntroductionFormApi from "../../../../../services/api/introductionForm";
// import style from "../../../../../components/common/Table/table.style";
// OLD: Incorrect path - ../FriendToMemberTrend/Components/tablestyle
// NEW: Fixed path - need to go up two directories to reach FriendToMemberTrend folder
import style from "../../FriendToMemberTrend/Components/tablestyle";

// OLD:
// const BLOCK = "BLOCK";

const getDivisionColumns = () => {
  // OLD:
  // return [
  //   { key: "total", label: "Total Count", color: "#424242" },
  //   { key: "target", label: "Target", color: "#111827" },
  //   { key: "md", label: "MD", color: "#2563eb" },
  //   { key: "wd", label: "WD", color: "#7c3aed" },
  //   { key: "ymd", label: "YMD", color: "#0891b2" },
  //   { key: "ywd", label: "YWD", color: "#059669" },
  //   { key: "fdb", label: "FDB", color: "#dc2626" },
  //   { key: "fdg", label: "FDG", color: "#d97706" },
  // ];

  // NEW: As per updated UI requirement
  // Columns: Total Count, Target Progress, Target, MD, WD, YMD, YWD, FDB, FDG
  return [
    { key: "total", label: "Total Count", color: "#424242" },
    { key: "targetProgress", label: "Target Progress", color: "#374151" },
    { key: "target", label: "Target", color: "#111827" },
    { key: "md", label: "MD", color: "#2563eb" },
    { key: "wd", label: "WD", color: "#7c3aed" },
    { key: "ymd", label: "YMD", color: "#0891b2" },
    { key: "ywd", label: "YWD", color: "#059669" },
    { key: "fdb", label: "FDB", color: "#dc2626" },
    { key: "fdg", label: "FDG", color: "#d97706" },
  ];
};

const HIERARCHY_TO_LABEL = {
  ZONE: "Zone",
  REGION: "Region",
  CHAPTER: "Chapter",
  DISTRICT: "District",
  // OLD:
  // BLOCK: "Block",
};

const HIERARCHY_TO_NEXT_QUERY_KEY = {
  ZONE: "zoneId",
  REGION: "regionId",
  CHAPTER: "chapterId",
  // DISTRICT: "districtId",
  // OLD:
  // BLOCK: "blockId",
  // NEW: Block is the lowest level in hierarchy; no drill-down beyond this.
};

const FILTER_KEY_ORDER = [
  "areaId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  // OLD:
  // "blockId",
];

// OLD (implicit default Typography sizing)
// NEW: slightly larger font for this report table
const TABLE_FONT_SIZE = {
  header: "16px",
  body: "16px",
};

const EXPAND_ICON_STYLE = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "18px",
  height: "18px",
  borderRadius: "6px",
  border: "1px solid #cbd5e1",
  backgroundColor: "#f8fafc",
  color: "#0f172a",
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: 1,
  marginLeft: "8px",
};

function Table({ checkAllToggle, columns, rows, baseQuery, fetchChildren }) {
  const divisionColumns = getDivisionColumns();
  const [expandedKeys, setExpandedKeys] = React.useState({});
  const [childrenByKey, setChildrenByKey] = React.useState({});
  const [loadingKeys, setLoadingKeys] = React.useState({});

  const getProgressMeta = (total, target) => {
    if (!target || Number(target) <= 0) {
      return { percent: 0, barPercent: 0, color: "#94a3b8" };
    }
    const percent = Math.round((Number(total) / Number(target)) * 100);
    const barPercent = Math.max(0, Math.min(100, percent));
    let color = "#ef4444";
    if (percent >= 100) color = "#10b981";
    else if (percent >= 50) color = "#f59e0b";
    return { percent, barPercent, color };
  };

  const getStructureHeaderLabel = () => {
    const first = rows && rows.length ? rows[0] : null;
    const hierarchy = first?.hierarchy;
    return HIERARCHY_TO_LABEL[hierarchy] || "Structure";
  };

  // OLD: URL based drill-down navigation (kept for future use)
  // const handleStructureClick = (row) => {
  //   if (!row) return;
  //   const hierarchy = row?.hierarchy;
  //   const nextKey = HIERARCHY_TO_NEXT_QUERY_KEY[hierarchy];
  //   const id = row?.structureId;
  //   if (!nextKey || !id) return;
  //   ...
  // };

  const getRowKey = (row) => `${row?.hierarchy}-${row?.structureId}`;

  const buildChildQuery = (row, rowContextQuery) => {
    const nextKey = HIERARCHY_TO_NEXT_QUERY_KEY[row?.hierarchy];
    if (!nextKey) return null;

    const query = { ...(rowContextQuery || baseQuery || {}) };

    // Ensure parent id is applied
    query[nextKey] = row.structureId;

    // Remove deeper keys after nextKey
    const nextIndex = FILTER_KEY_ORDER.indexOf(nextKey);
    FILTER_KEY_ORDER.slice(nextIndex + 1).forEach((k) => {
      delete query[k];
    });

    // Always reset pagination keys if present
    delete query.pageNumber;
    delete query.pageSize;

    return query;
  };

  const onToggleExpand = async (row) => {
    const rowKey = getRowKey(row);
    const isExpandable = !!HIERARCHY_TO_NEXT_QUERY_KEY[row?.hierarchy];
    if (!isExpandable) return;

    const nextExpanded = !expandedKeys[rowKey];
    setExpandedKeys((prev) => ({ ...prev, [rowKey]: nextExpanded }));
    if (!nextExpanded) return;

    if (childrenByKey[rowKey]) return;
    if (!fetchChildren) return;

    const childQuery = buildChildQuery(row, row?.contextQuery);
    if (!childQuery) return;

    setLoadingKeys((prev) => ({ ...prev, [rowKey]: true }));
    try {
      // OLD: Only fetch children from report API
      // const childRows = await fetchChildren(childQuery);
      // setChildrenByKey((prev) => ({ ...prev, [rowKey]: childRows || [] }));

      const childRows = await fetchChildren(childQuery);

      // NEW: Chapter -> District expand should show districts even with 0 growth
      // Report API may return only those structures where growth exists.
      if (row?.hierarchy === "CHAPTER") {
        const reportRows = Array.isArray(childRows) ? childRows : [];
        let allDistricts = [];
        try {
          const districtsRes = await IntroductionFormApi.getAllDistricts({
            data: { chapterId: row?.structureId },
          });
          allDistricts = Array.isArray(districtsRes?.data)
            ? districtsRes.data
            : [];
        } catch (e) {
          allDistricts = [];
        }

        const reportById = new Map(
          reportRows.map((r) => [Number(r?.structureId), r])
        );

        // OLD: for missing districts we were defaulting to targetCount=0, causing 0/0 in UI
        // const merged = (allDistricts || []).map((d) => {
        //   const id = Number(d?.districtId ?? d?.structureId ?? d?.id);
        //   const name = d?.districtName ?? d?.structureName ?? d?.name ?? d?.entityTitle;
        //   const rr = reportById.get(id);
        //   return (
        //     rr || {
        //       structureId: id,
        //       structureName: name,
        //       hierarchy: "DISTRICT",
        //       mdcount: 0,
        //       wdcount: 0,
        //       ymdcount: 0,
        //       ywdcount: 0,
        //       fdbcount: 0,
        //       fdgcount: 0,
        //       targetCount: 0,
        //     }
        //   );
        // });

        const inferredTarget = reportRows.reduce(
          (max, r) => Math.max(max, Number(r?.targetCount || 0)),
          0
        );

        const merged = await Promise.all(
          (allDistricts || []).map(async (d) => {
            const id = Number(d?.districtId ?? d?.structureId ?? d?.id);
            const name =
              d?.districtName ?? d?.structureName ?? d?.name ?? d?.entityTitle;

            const rr = reportById.get(id);
            if (rr) return rr;

            // For districts not returned by chapter-level report API, fetch district-level row
            // so targetCount is consistent (e.g., 0/14 not 0/0).
            try {
              const districtRows = await fetchChildren({
                ...(childQuery || {}),
                districtId: id,
              });
              const first = Array.isArray(districtRows)
                ? districtRows[0]
                : null;
              if (first && Number(first?.structureId) === id) {
                return first;
              }
            } catch (e) {
              // ignore and fallback
            }

            return {
              structureId: id,
              structureName: name,
              hierarchy: "DISTRICT",
              mdcount: 0,
              wdcount: 0,
              ymdcount: 0,
              ywdcount: 0,
              fdbcount: 0,
              fdgcount: 0,
              targetCount: inferredTarget,
            };
          })
        );

        // If districts API fails/returns empty, fallback to report rows
        setChildrenByKey((prev) => ({
          ...prev,
          [rowKey]: merged.length ? merged : reportRows,
        }));
        return;
      }

      setChildrenByKey((prev) => ({ ...prev, [rowKey]: childRows || [] }));
    } finally {
      setLoadingKeys((prev) => ({ ...prev, [rowKey]: false }));
    }
  };

  const renderTableHeader = () => {
    return (
      <TableHead>
        <TableRow>
          <TableCell
            align="left"
            sx={{
              ...style.tableHeadCell,
              ...style.headerCell,
              position: "sticky",
              left: 0,
              zIndex: 3,
              backgroundColor: "#f8fafc",
              minWidth: "120px",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <Typography
              variant="small"
              weight={600}
              // OLD: default font size
              // style={{ fontSize: "13px", color: "#000000" }}
              style={{ fontSize: TABLE_FONT_SIZE.header, color: "#000000" }}
            >
              {getStructureHeaderLabel()}
            </Typography>
          </TableCell>

          {divisionColumns.map((division, index) => (
            <TableCell
              key={index}
              align="center"
              sx={{
                ...style.tableHeadCell,
                ...style.headerCell,
                minWidth: "80px",
                backgroundColor: division.color,
                color: "#fff",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <Typography
                variant="small"
                weight={600}
                // OLD: default font size
                // style={{ fontSize: "13px", color: "#fff" }}
                style={{ fontSize: TABLE_FONT_SIZE.header, color: "#fff" }}
              >
                {division.label}
              </Typography>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const renderTableBody = () => {
    if (!rows || rows.length === 0) {
      return (
        <TableBody>
          <TableRow>
            <TableCell
              colSpan={divisionColumns.length + 1}
              align="center"
              sx={{ padding: "20px" }}
            >
              <Typography variant="body2" color="textSecondary">
                No data available
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      );
    }

    // Group data by structure
    const groupedData = {};
    rows.forEach((row) => {
      // OLD: was using structureType, but backend response doesn't include it for this report
      // const key = `${row.structureName}-${row.structureType}`;
      // NEW: Stable unique key using structureId + hierarchy
      const key = `${row.structureId}-${row.hierarchy}`;
      if (!groupedData[key]) {
        groupedData[key] = {
          structureName: row.structureName,
          structureId: row.structureId,
          hierarchy: row.hierarchy,
          // NEW: preserve context for nested expand/collapse
          // This query represents the filters that produced this row list
          // For top-level list it will be the current baseQuery (e.g. {areaId})
          contextQuery: { ...(baseQuery || {}) },
          md: 0,
          wd: 0,
          ymd: 0,
          ywd: 0,
          fdb: 0,
          fdg: 0,
          total: 0,
          target: 0,
        };
      }
      // Aggregate data for the same structure
      groupedData[key].md += row.mdcount || 0;
      groupedData[key].wd += row.wdcount || 0;
      groupedData[key].ymd += row.ymdcount || 0;
      groupedData[key].ywd += row.ywdcount || 0;
      groupedData[key].fdb += row.fdbcount || 0;
      groupedData[key].fdg += row.fdgcount || 0;
      groupedData[key].target += row.targetCount || 0;

      // OLD: total was (incorrectly) including target
      // groupedData[key].total =
      //   groupedData[key].md +
      //   groupedData[key].wd +
      //   groupedData[key].ymd +
      //   groupedData[key].ywd +
      //   groupedData[key].fdb +
      //   groupedData[key].fdg +
      //   groupedData[key].target;

      groupedData[key].total =
        groupedData[key].md +
        groupedData[key].wd +
        groupedData[key].ymd +
        groupedData[key].ywd +
        groupedData[key].fdb +
        groupedData[key].fdg;
    });

    const renderGroupRow = (group, groupIndex, level) => {
      const rowKey = getRowKey(group);
      // const isExpandable = !!HIERARCHY_TO_NEXT_QUERY_KEY[group?.hierarchy];
      const isExpandable =
        group?.hierarchy !== "DISTRICT" &&
        !!HIERARCHY_TO_NEXT_QUERY_KEY[group?.hierarchy];
      const isExpanded = !!expandedKeys[rowKey];
      const isLoading = !!loadingKeys[rowKey];
      const paddingLeft = `${level * 18}px`;
      const childContextQuery = isExpandable
        ? buildChildQuery(group, group?.contextQuery)
        : null;

      return (
        <React.Fragment key={`${rowKey}-${groupIndex}-${level}`}>
          <TableRow
            sx={{
              "&:hover": {
                backgroundColor: "#f8fafc",
              },
            }}
          >
            <TableCell
              sx={{
                ...style.tableCell,
                position: "sticky",
                left: 0,
                zIndex: 2,
                backgroundColor: "#fff",
                minWidth: "120px",
                fontWeight: 500,
                paddingLeft,
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              {(() => {
                if (!isExpandable) {
                  return (
                    <Typography
                      variant="body2"
                      style={{ fontSize: TABLE_FONT_SIZE.body }}
                    >
                      {group.structureName}
                    </Typography>
                  );
                }

                return (
                  <Typography
                    variant="body2"
                    pointer
                    style={{
                      fontSize: TABLE_FONT_SIZE.body,
                      marginLeft: "4px",
                      color: "#0f172a",
                      fontWeight: 700,
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                    // onClick={() => onToggleExpand(group)}
                    onClick={() => {
                      if (group?.hierarchy === "DISTRICT") return;
                      onToggleExpand(group);
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.opacity = "0.85";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.opacity = "1";
                    }}
                  >
                    {group.structureName}
                    {isLoading ? " ..." : ""}
                    <Box component="span" sx={EXPAND_ICON_STYLE}>
                      {isExpanded ? "-" : "+"}
                    </Box>
                  </Typography>
                );
              })()}
            </TableCell>

            {divisionColumns.map((division, divisionIndex) => {
              if (division.key === "targetProgress") {
                const meta = getProgressMeta(group.total, group.target);
                return (
                  <TableCell
                    key={divisionIndex}
                    align="center"
                    sx={{
                      ...style.tableCell,
                      minWidth: "140px",
                      borderBottom: "1px solid #e5e7eb",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          width: "90px",
                          height: "10px",
                          borderRadius: "999px",
                          backgroundColor: "#e5e7eb",
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          sx={{
                            width: `${meta.barPercent}%`,
                            height: "100%",
                            backgroundColor: meta.color,
                            borderRadius: "999px",
                          }}
                        />
                      </Box>

                      <Typography
                        variant="body2"
                        style={{
                          fontSize: TABLE_FONT_SIZE.body,
                          fontWeight: 700,
                          color: meta.color,
                          minWidth: "44px",
                          textAlign: "right",
                        }}
                      >
                        {`${meta.percent}%`}
                      </Typography>
                    </Box>
                  </TableCell>
                );
              }

              const getValue = () => {
                switch (division.key) {
                  case "total":
                    return `${group.total}/${group.target}`;
                  case "target":
                    return group.target;
                  case "md":
                    return group.md;
                  case "wd":
                    return group.wd;
                  case "ymd":
                    return group.ymd;
                  case "ywd":
                    return group.ywd;
                  case "fdb":
                    return group.fdb;
                  case "fdg":
                    return group.fdg;
                  default:
                    return 0;
                }
              };

              const rawValue = getValue();
              const isNumeric = typeof rawValue === "number";
              return (
                <TableCell
                  key={divisionIndex}
                  align="center"
                  sx={{
                    ...style.tableCell,
                    minWidth: "80px",
                    backgroundColor:
                      isNumeric && rawValue > 0
                        ? `${division.color}15`
                        : "transparent",
                    borderBottom: "1px solid #e5e7eb",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      fontSize: TABLE_FONT_SIZE.body,
                      fontWeight: isNumeric && rawValue > 0 ? 600 : 400,
                    }}
                  >
                    {rawValue}
                  </Typography>
                </TableCell>
              );
            })}
          </TableRow>

          {isExpandable &&
          isExpanded &&
          (childrenByKey[rowKey] || []).length > 0
            ? (() => {
                // Child rows are returned by API, but they may contain repeated structure; render directly
                const childRows = childrenByKey[rowKey] || [];
                return childRows.map((child, idx) => {
                  const childGroup = {
                    structureName: child.structureName,
                    structureId: child.structureId,
                    hierarchy: child.hierarchy,
                    // NEW: set contextQuery for deeper drill-down
                    contextQuery: {
                      ...(childContextQuery || group.contextQuery || {}),
                    },
                    md: child.mdcount || 0,
                    wd: child.wdcount || 0,
                    ymd: child.ymdcount || 0,
                    ywd: child.ywdcount || 0,
                    fdb: child.fdbcount || 0,
                    fdg: child.fdgcount || 0,
                    target: child.targetCount || 0,
                    total:
                      (child.mdcount || 0) +
                      (child.wdcount || 0) +
                      (child.ymdcount || 0) +
                      (child.ywdcount || 0) +
                      (child.fdbcount || 0) +
                      (child.fdgcount || 0),
                  };
                  return renderGroupRow(childGroup, idx, level + 1);
                });
              })()
            : null}
        </React.Fragment>
      );
    };

    return (
      <TableBody>
        {Object.values(groupedData).map((group, groupIndex) =>
          renderGroupRow(group, groupIndex, 0)
        )}
      </TableBody>
    );
  };

  return (
    <TableContainer
      sx={{
        maxHeight: "calc(100vh - 300px)",
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        // OLD: overflow hidden was clipping expanded child rows and hiding scrollbars
        // overflow: "hidden",
        // NEW: allow scroll when nested rows expand
        overflowY: "auto",
        overflowX: "auto",
        boxShadow: "0 6px 18px rgba(15, 23, 42, 0.08)",
        backgroundColor: "#ffffff",
      }}
    >
      <MuiTable
        stickyHeader
        sx={{
          "& .MuiTableCell-root": {
            paddingTop: "12px",
            paddingBottom: "12px",
          },
        }}
      >
        {renderTableHeader()}
        {renderTableBody()}
      </MuiTable>
    </TableContainer>
  );
}

Table.propTypes = {
  checkAllToggle: PropTypes.func,
  columns: PropTypes.array,
  rows: PropTypes.array,
  baseQuery: PropTypes.object,
  fetchChildren: PropTypes.func,
};

Table.defaultProps = {
  checkAllToggle: () => {},
  columns: [],
  rows: [],
  baseQuery: {},
  fetchChildren: null,
};

export default Table;
